import { Page } from '@tassomutuo-backoffice/types';
import { axiosApiInstancePrivate } from '../index';
import axios, { AxiosError } from 'axios';
import configEnv from '../../../config/config';

export const getAllPagesInProd = async (): Promise<Page[]> => {
  try {
    const response = await axios.get<{ results: Page[] }>(
      `${configEnv.apiUrlTassoProduction}/v1/page/all`
    );

    return response.data?.results || [];
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getAllPages = async (): Promise<Page[]> => {
  try {
    const response = await axiosApiInstancePrivate.get<{ results: Page[] }>(
      `/v1/page/all`
    );

    return response.data?.results || [];
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const deletePage = async (id: string): Promise<Page> => {
  try {
    const response = await axiosApiInstancePrivate.delete<Page>(
      `/v1/page/${id}`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const publishPageInProd = async (pageId: string): Promise<Page> => {
  try {
    const response = await axiosApiInstancePrivate.post<Page>(
      `/v1/page/publish-to-prod-client`,
      {
        pageId,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const togglePageHighlightedInGlossary = async (
  pageId: string
): Promise<Page> => {
  try {
    const response = await axiosApiInstancePrivate.post<Page>(
      `/v1/page/toggle-highlighted-in-glossary`,
      {
        pageId,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const publishMultiplePagesInProd = async (
  pageIds: string[]
): Promise<void> => {
  try {
    const response = await axiosApiInstancePrivate.post<void>(
      `/v1/page/publish-multiple-to-prod-client`,
      {
        pageIds,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const syncPageWithCms = async (
  contentType: 'page' | 'post',
  id: number
): Promise<void> => {
  try {
    const endpoint =
      contentType === 'post' ? `/v1/wp/posts/${id}` : `/v1/wp/pages/${id}`;
    await axiosApiInstancePrivate.get<void>(endpoint);
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const syncMultiplePagesWithCms = async (
  pagesData: { contentType: 'page' | 'post'; idCms: number }[]
): Promise<void> => {
  try {
    await axiosApiInstancePrivate.post<void>(`/v1/wp/sync-multiple`, {
      pagesData,
    });
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};
